import AppRoutes from '../../config/AppRoutes';

const tabList = [
  {
    label: 'Question',
    idFieldName: 'questionId',
    // SAVED ITEM LIST START HERE
    favAPIService: 'fetchSavedQuestion',
    saveItemDeleteAPIService: 'deleteSavedQuestion',
    savedItemTitle: 'Question ID', // that is tabs title with ID
    saveItemTableName: 'question', // table name to access object or save item
    savedItemTableKey: 'name', // key name to represent topic which is show in tab

    //* REPORTED ITEM LIST START HERE
    reportAPIService: 'fetchReportedQuestion',
    reportedItemTableKey: 'comment',
    reportDeleteAPIService: 'deleteReportedQuestion',
    // VIEW ITEM LIST START HERE
    viewItemAPIService: 'redirectToQuestion',
    redirectionPath: AppRoutes.CFA1_2025_QUESTION_VIEW,
    // EDIT REPORT LIST START HERE
    editAPIService: 'updateReportedQuestion',
  },
  {
    label: 'Notes',
    //* SAVED ITEM LIST START HERE
    favAPIService: 'fetchSavedNotes',
    idFieldName: 'notesId',
    saveItemDeleteAPIService: 'deleteSavedNotes',
    savedItemTitle: 'Notes ID', // that is tabs title with ID
    saveItemTableName: 'cfa1_2025_note', // table name to access object or save item
    savedItemTableKey: 'name', // key name to represent topic which is show in tab
    //* REPORTED ITEM LIST START HERE
    reportAPIService: 'fetchReportedNotes',
    reportedItemTableKey: 'comment',
    reportDeleteAPIService: 'deleteReportedNotes',
    //* VIEW ITEM LIST START HERE
    viewItemAPIService: 'redirectToNotes',
    redirectionPath: AppRoutes.CFA1_2025_NOTES_VIEW,
    //* EDIT REPORT LIST START HERE
    editAPIService: 'updateReportedNotes',
  },
  {
    label: 'Video',
    //* SAVED ITEM LIST START HERE
    idFieldName: 'video_id',
    favAPIService: 'fetchSavedVideos',
    saveItemDeleteAPIService: 'deleteSavedVideo',
    savedItemTitle: 'Video Id', // that is tabs title with ID
    saveItemTableName: 'cfa1_2025_video', // table name to access object or save item
    savedItemTableKey: 'name', // key name to represent topic which is show in tab
    //* REPORTED ITEM LIST START HERE
    reportAPIService: 'fetchReportedVideos',
    reportedItemTableKey: 'comment',
    reportDeleteAPIService: 'deleteReportedVideo',
    //* VIEW ITEM LIST START HERE
    viewItemAPIService: 'redirectToVideos',
    redirectionPath: AppRoutes.CFA1_VIDEO_LIST,
    //* EDIT REPORT LIST START HERE
    editAPIService: 'updateReportedVideo',
  },
  {
    label: 'Mocks',
    idFieldName: 'questionId',
    reportAPIService: 'fetchCBTReportedQuestion',
    savedItemTitle: 'CBT Question ID',
    saveItemTableName: 'cfa_cbt_question',
    savedItemTableKey: 'name', // key name to represent topic which is show in tab
    reportedItemTableKey: 'comment',
    viewItemAPIService: 'redirectToCbtQuestion',
    redirectionPath: AppRoutes.CFA1_2024_CBT_QUESTION_FINISH,
    reportDeleteAPIService: 'deleteCBTReportedQuestion',
    // EDIT REPORT LIST START HERE
    editAPIService: 'updateReportedCBTQuestion',
  },
];

export default tabList;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Dashboard/tabList.js